<template>
  <div id="add-user-modal" class="modal" v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>ユーザーの編集</h2>
      </div>
      <div class="data-area">
        <ul>
          <li>ユーザー
            <span class="label">ユーザータイプ</span>
            <select v-model="editObj.userType">
              <option v-for="(type,index) in userTypeList" :key="index" :value="type.code">{{type.label}}</option>
            </select>
          </li>
        </ul>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" @click="updateUser">変更</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  <!-- ローディングモーダル -->
  <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import store from '../../../store/index'

import axios from 'axios'
import * as AppUtils from '../../../utils/App'
import * as Api from '../../../utils/Api'
import {DC_URL} from '../../../constants/App'
import {USER_TYPE} from '../../constants/TypeEc'
import LoadingModal from '../../../components/common/LoadingModal'
export default {
  name: 'addNewUserModal',
  store: store,
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    userObj: Object
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** ユーザータイプ */
      userTypeList: USER_TYPE,
      validateErrorMessages: {},
      errorMessage: { text: '' }
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
  },
  methods: {
    showModal: function () {
      this.editObj = Object.assign({}, this.userObj)
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
    },
    updateUser: function () {
      let payload = {
        userId: this.editObj.userId,
        userType: this.editObj.userType
      }
      axios.post(DC_URL.USER + '/change-user-type', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.errorMessage.text = response.data.errorMessage
        } else {
          this.$store.dispatch('loadUserListDc')
          this.modalShown = false
          let modalData = {
            messages: ['変更しました。']
          }
          AppUtils.showModal(modalData)
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  .label{
    min-width: 135px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
select{
  width: 196px;
}
.del_st {
  margin-left: 100px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/DcUserEditModal.vue